export default __webpack_public_path__ + "static/cruiselogo_msc-13550b154a31995b00bb1367701f03d2.png";